import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import login_img from "../../assets/images/login_img.png";
import login_logo from "../../assets/images/login_logo.png";
import eye_icon from "../../assets/images/eye_icon.svg";
import eye_slash_icon from "../../assets/images/eye_slash_icon.svg";
import { resetPassword } from "../../store/slices/authSlice";
import { encryptPassword } from "../../utils/cryptoUtils";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [localError, setLocalError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();
  const { loading, error, success } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setLocalError("Passwords do not match");
      return;
    }
    setLocalError("");

    // Encrypt passwords before sending to API
    const encryptedNewPassword = await encryptPassword(newPassword);
    const encryptedConfirmPassword = await encryptPassword(confirmPassword);

    dispatch(resetPassword({ email, resetCode: code, newPassword: encryptedNewPassword, confirmPassword: encryptedConfirmPassword })).then(() => {
      navigate("/");
    });
  };

  return (
    <div className="login py_14">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div className="col-md-6 h-100">
            <div className="login_image">
              <div className="content_set">
                <div className="login_text_overlay">
                  <h2>
                    Smart Accounting <br />
                    Starts Here
                  </h2>
                  <p>
                    Manage users, bank accounts, and payroll — securely and <br />
                    efficiently with UnivisionCPA.
                  </p>
                </div>
                <div className="login_content"></div>
                <div className="login_total"></div>
              </div>

              <img src={login_img} alt="Login Background" />

              {/* ✅ Add text overlay here */}


            </div>
          </div>

          <div className="col-md-6">
            <div className="login_form h-100 d-flex flex-column align-item-center justify-content-center px_50">
              <img src={login_logo} className="w-auto mw-auto mb_60" />

              <h4 className="mb_4">Reset Password</h4>
              <p>Please provide your credentials reset password.</p>

              <form onSubmit={handleSubmit} className="common_input_forms mt_0">
                <div className="form_group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form_group_wrapper">
                  <div className="form_group">
                    <label>Password</label>
                    <div className="">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                      />
                      <img
                        src={showPassword ? eye_slash_icon : eye_icon}
                        alt="Toggle password visibility"
                        className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                        style={{ width: "20px", height: "20px", cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form_group_wrapper">
                  <div className="form_group">
                    <label>Confirm Password</label>
                    <div className="">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                      />
                      <img
                        src={showConfirmPassword ? eye_slash_icon : eye_icon}
                        alt="Toggle confirm password visibility"
                        className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                        style={{ width: "20px", height: "20px", cursor: "pointer" }}
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      />
                    </div>
                  </div>
                  {localError && <div className="text-danger mt-2">{localError}</div>}
                </div>

                {error && <div className="text-danger mt_20">{error}</div>}

                {success && <div className="text-success mt_20">{success}</div>}

                <div className="d-flex mt_30">
                  <div className="w-50">
                    <a href="/" className="btn_link">
                      Back to login
                    </a>
                  </div>

                  <div className="w-50">
                    <button type="submit" className="btn btn_primary px_30 ms-auto" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Submitting
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
